import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '../../../../shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-pk-users-matching-dialog',
    template: `
        <p>{{ 'pk.matching_users_dialog_p_1' | fiAppText }}</p>
        <p [innerHTML]="'pk.matching_users_dialog_p_2' | fiAppText"></p>
        <p class="bold">{{ 'pk.matching_users_dialog_p_3' | fiAppText }}</p>
        <p>{{ 'pk.matching_users_dialog_p_4' | fiAppText }}</p>
    `,
    styleUrls: ['./fi-pk-users-matching-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-pk-users-matching-dialog' },
    standalone: false,
})
export class FiPkUsersMatchingDialogComponent extends FiDialogsContentBase<undefined, undefined> {}
